var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalculatorApp = function SvgCalculatorApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".calculator-app_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.004 19-4-4M4.004 19l4-4M6.004 4.5v5M8.504 7h-5M15.504 7h5M15.504 18h5M15.504 18h5M15.504 16h5M12.004 1v22M1.004 12h22",
    className: "calculator-app_svg__a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 1.004,
    y: 1,
    className: "calculator-app_svg__a",
    rx: 3,
    ry: 3
  })));
};
export default SvgCalculatorApp;